import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";

/*
 * @Author       : Zhelin Cheng
 * @Date         : 2021-05-06 10:39:24
 * @LastEditors  : 程哲林
 * @LastEditTime : 2024-02-22 11:01:04
 * @FilePath     : /marketing-landing-fe/src/utils/bridge.ts
 * @Description  : 未添加文件描述
 */
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (g && (g = 0, op[0] && (_ = 0)), _) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { customError } from '@woulsl/sentry-config';
import JsBridge from '@woulsl-app/js-bridge';
import Cookies from 'js-cookie';
import { envName } from '@/const';
import { MINI_PROGRAM_CONFIG_KEY, MINIP_INFO as miniInfo, PACKAGE_NAME, UC_API_DOMAIN } from '@/const';
import { getApolloKey } from '@/services/landing';
import { isApple, isDouDouBrowser, isJoJoBeansBrowser, isJoJoReadBrowser, isJoJoUpBrowser, isJoJoUpRemakeBrowser, qsParse, reportError } from '@/utils';
import { getIsWindowModel } from './getIsWIndow';
import { isJoJoBrowser } from './index';
var bridge = isJoJoBrowser() ? new JsBridge() : {};
var canUseBridge = bridge.canUseBridge ? bridge.canUseBridge() : false;
var isJoJoApp = isJoJoBrowser();

var jojoWeChatInstalled = function jojoWeChatInstalled() {
  return __awaiter(void 0, void 0, void 0, function () {
    var isJJWeChatInstalled, res, e_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          isJJWeChatInstalled = true;
          _a.label = 1;

        case 1:
          _a.trys.push([1, 4,, 5]);

          if (!(isJoJoApp && canUseBridge)) return [3
          /*break*/
          , 3];
          return [4
          /*yield*/
          , bridge.isWechatInstalled()];

        case 2:
          res = _a.sent();
          console.log('微信安装', res, res.data.isInstalled);

          if (res.status === 200) {
            isJJWeChatInstalled = Boolean(res.data.isInstalled);
          }

          _a.label = 3;

        case 3:
          return [3
          /*break*/
          , 5];

        case 4:
          e_1 = _a.sent();
          console.error(e_1);
          return [3
          /*break*/
          , 5];

        case 5:
          return [2
          /*return*/
          , isJJWeChatInstalled];
      }
    });
  });
};

var jojoAppLogin = function jojoAppLogin(url) {
  if (url === void 0) {
    url = '';
  }

  return __awaiter(void 0, void 0, void 0, function () {
    var _a, status_1, data, e_2;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          _b.trys.push([0, 2,, 3]);

          if (!isJoJoApp) {
            return [2
            /*return*/
            , 2];
          }

          if (Cookies.get('authToken')) {
            return [2
            /*return*/
            , 1];
          }

          return [4
          /*yield*/
          , bridge.call('nativeLogin')];

        case 1:
          _a = _b.sent(), status_1 = _a.status, data = _a.data;

          if (status_1 === 200 && data && (data === null || data === void 0 ? void 0 : data.authToken)) {
            window.location.href = "".concat(UC_API_DOMAIN, "/page/appWeb/portal/appWebLogin?authToken=").concat(data === null || data === void 0 ? void 0 : data.authToken, "&packageName=").concat(PACKAGE_NAME, "&targetUrl=").concat(url || window.location.href);
          } else {
            return [2
            /*return*/
            , 0];
          }

          return [3
          /*break*/
          , 3];

        case 2:
          e_2 = _b.sent();
          console.error(e_2);
          return [2
          /*return*/
          , 0];

        case 3:
          return [2
          /*return*/
          , 3];
      }
    });
  });
}; // 直接登录


var loginTimer = null;

var jojoAppDirectLogin = function jojoAppDirectLogin(url, cb) {
  if (url === void 0) {
    url = '';
  }

  clearTimeout(loginTimer);
  loginTimer = setTimeout(function () {
    return __awaiter(void 0, void 0, void 0, function () {
      var ua, sta, packageName, _a, _b, status_2, data, bundleID, e_3;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            ua = window.navigator.userAgent;
            sta = -1;
            _c.label = 1;

          case 1:
            _c.trys.push([1, 3,, 4]);

            packageName = PACKAGE_NAME;
            return [4
            /*yield*/
            , Promise.all([bridge.call('nativeLogin'), getAppInfo()])];

          case 2:
            _a = _c.sent(), _b = _a[0], status_2 = _b.status, data = _b.data, bundleID = _a[1].bundleID;
            console.log(status_2, data, bundleID);

            if (/huiben/gim.test(ua)) {
              packageName = 'com.jojoread.huiben';
            } else if (bundleID) {
              packageName = bundleID;
            }

            sta = status_2;

            if (status_2 === 200 && data && data.authToken) {
              window.location.href = "".concat(UC_API_DOMAIN, "/page/appWeb/portal/appWebLogin?authToken=").concat(data.authToken, "&packageName=").concat(packageName, "&targetUrl=").concat(encodeURIComponent(url || window.location.href));
            }

            return [3
            /*break*/
            , 4];

          case 3:
            e_3 = _c.sent();
            customError({
              name: '调用APP登陆失败',
              message: e_3.message || sta.toString(),
              stack: e_3.stack
            });
            return [3
            /*break*/
            , 4];

          case 4:
            if (typeof cb === 'function') {
              cb(sta);
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  }, 300);
};

var jojoAppOnlyDirectLogin = function jojoAppOnlyDirectLogin(url, cb) {
  if (url === void 0) {
    url = '';
  }

  clearTimeout(loginTimer);
  loginTimer = setTimeout(function () {
    return __awaiter(void 0, void 0, void 0, function () {
      var ua, sta, packageName, _a, _b, status_3, data, bundleID, e_4;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            ua = window.navigator.userAgent;
            sta = -1;
            _c.label = 1;

          case 1:
            _c.trys.push([1, 3,, 4]);

            packageName = PACKAGE_NAME;
            return [4
            /*yield*/
            , Promise.all([bridge.call('nativeOnlyLogin'), getAppInfo()])];

          case 2:
            _a = _c.sent(), _b = _a[0], status_3 = _b.status, data = _b.data, bundleID = _a[1].bundleID;
            console.log(status_3, data, bundleID);

            if (/huiben/gim.test(ua)) {
              packageName = 'com.jojoread.huiben';
            } else if (bundleID) {
              packageName = bundleID;
            }

            sta = status_3;

            if (status_3 === 200 && data && data.authToken) {
              window.location.href = "".concat(UC_API_DOMAIN, "/page/appWeb/portal/appWebLogin?authToken=").concat(data.authToken, "&packageName=").concat(packageName, "&targetUrl=").concat(encodeURIComponent(url || window.location.href));
            }

            return [3
            /*break*/
            , 4];

          case 3:
            e_4 = _c.sent();
            customError({
              name: '调用APP登陆失败',
              message: e_4.message || sta.toString(),
              stack: e_4.stack
            });
            return [3
            /*break*/
            , 4];

          case 4:
            if (typeof cb === 'function') {
              cb(sta);
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  }, 300);
};

var tinmanWxtrigger = function tinmanWxtrigger(data, scene, cb) {
  if (isJoJoApp) {
    if (canUseBridge) {
      bridge.call('shareToWX', {
        title: '',
        desc: '',
        url: '',
        scene: scene,
        shareType: 1,
        image: data
      }, function (res) {
        if (res === void 0) {
          res = {};
        }

        console.log(res);

        if (typeof cb === 'function') {
          cb(res);
        }
      });
    } else {
      reportError('不支持canUseBridge');
    }

    return;
  }

  var eventName = ['shareImageToWX', 'shareImageToWXCircle'][scene]; // 微信浏览器不处理

  if (/MicroMessenger/i.test(navigator.userAgent)) return;
  var parsedData = typeof data === 'string' ? data : JSON.stringify(data); // 新版android

  if (window.androidJs) {
    if (typeof window.androidJs[eventName] === 'function') {
      window.androidJs[eventName](parsedData);
    } // 新版ios

  } else if (window.webkit && window.webkit.messageHandlers) {
    if (window.webkit.messageHandlers[eventName] && typeof window.webkit.messageHandlers[eventName].postMessage === 'function') {
      window.webkit.messageHandlers[eventName].postMessage(parsedData);
    }
  } else {
    // 老版本schema的形式
    document.location = "jojoread://".concat(encodeURIComponent(JSON.stringify({
      event: eventName,
      data: parsedData
    })));
  }
};

export function jumpMiniApp(ops) {
  return __awaiter(this, void 0, void 0, function () {
    var MINI_INFO, _a, resultCode, data;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          MINI_INFO = miniInfo;
          return [4
          /*yield*/
          , getApolloKey((ops === null || ops === void 0 ? void 0 : ops.miniConf) || MINI_PROGRAM_CONFIG_KEY)];

        case 1:
          _a = _b.sent(), resultCode = _a.resultCode, data = _a.data;

          if (resultCode === 200 && data) {
            MINI_INFO = JSON.parse(data);
          }

          return [4
          /*yield*/
          , bridge.call('launchMiniProgram', {
            path: "/pages/transform_space/main?type=webview&needLogin=".concat(ops.needLogin || '1', "&linkUrl=").concat(encodeURIComponent(ops.linkUrl)),
            userName: MINI_INFO.userName,
            miniProgramType: Number(MINI_INFO.miniProgramType)
          })];

        case 2:
          return [2
          /*return*/
          , _b.sent()];
      }
    });
  });
}
export function jumpAddTeacherMiniApp(ops) {
  return __awaiter(this, void 0, void 0, function () {
    var MINI_INFO, _a, resultCode, data;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          MINI_INFO = miniInfo;
          return [4
          /*yield*/
          , getApolloKey((ops === null || ops === void 0 ? void 0 : ops.miniConf) || MINI_PROGRAM_CONFIG_KEY)];

        case 1:
          _a = _b.sent(), resultCode = _a.resultCode, data = _a.data;

          if (resultCode === 200 && data) {
            MINI_INFO = JSON.parse(data);
          }

          return [4
          /*yield*/
          , bridge.call('launchMiniProgram', {
            path: ops.linkUrl,
            userName: MINI_INFO.userName,
            miniProgramType: Number(MINI_INFO.miniProgramType)
          })];

        case 2:
          return [2
          /*return*/
          , _b.sent()];
      }
    });
  });
}
export function jojoAppBindPhone() {
  return __awaiter(this, void 0, void 0, function () {
    var _a, status_4, data, e_5;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          _b.trys.push([0, 2,, 3]);

          return [4
          /*yield*/
          , bridge.call('bindMobile')];

        case 1:
          _a = _b.sent(), status_4 = _a.status, data = _a.data;

          if (status_4 === 200 && data && (data === null || data === void 0 ? void 0 : data.mobile)) {
            return [2
            /*return*/
            , data.mobile];
          }

          return [3
          /*break*/
          , 3];

        case 2:
          e_5 = _b.sent();
          reportError(e_5);
          return [3
          /*break*/
          , 3];

        case 3:
          return [2
          /*return*/
          , ''];
      }
    });
  });
}
var appInfo = {};
export function getAppInfo() {
  return __awaiter(this, void 0, void 0, function () {
    var _a, status_5, data, e_6;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          if (appInfo.appName || !(isJoJoApp && canUseBridge)) {
            return [2
            /*return*/
            , appInfo];
          }

          _b.label = 1;

        case 1:
          _b.trys.push([1, 3,, 4]);

          return [4
          /*yield*/
          , bridge.call('appInfo')];

        case 2:
          _a = _b.sent(), status_5 = _a.status, data = _a.data;

          if (status_5 === 200) {
            appInfo = data;
            return [2
            /*return*/
            , data];
          }

          return [3
          /*break*/
          , 4];

        case 3:
          e_6 = _b.sent();
          console.error(e_6);
          return [3
          /*break*/
          , 4];

        case 4:
          return [2
          /*return*/
          , {}];
      }
    });
  });
}
export function getAppAudit() {
  return __awaiter(this, void 0, void 0, function () {
    var isDouDouApp, isMatchedApp, _a, status_6, data, authToken, e_7;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          _b.trys.push([0, 3,, 4]);

          isDouDouApp = isDouDouBrowser();
          isMatchedApp = isJoJoReadBrowser() || isJoJoBeansBrowser() || isJoJoUpRemakeBrowser() || isDouDouApp;
          console.log(isMatchedApp, 'isMatchedApp');
          if (!(isApple() && isMatchedApp && canUseBridge)) return [3
          /*break*/
          , 2];
          return [4
          /*yield*/
          , bridge.call('getDeviceInfo')];

        case 1:
          _a = _b.sent(), status_6 = _a.status, data = _a.data;

          try {
            if (window.__store) {
              __store.jojoDeviceInfo = data;
            }
          } catch (error) {
            console.error(error);
          }

          console.log('getDeviceInfo======', data, status_6);

          if (status_6 === 200 && data) {
            authToken = '';

            if (isDouDouApp) {
              authToken = Cookies.get('authToken');
            }

            return [2
            /*return*/
            , {
              audit: data.iosAudit === '1' || data.horizon === '1',
              guest: data.iosAuditVisitor === '1' || data.anonymous === '1' || Boolean(isDouDouApp && !authToken)
            }];
          }

          _b.label = 2;

        case 2:
          return [3
          /*break*/
          , 4];

        case 3:
          e_7 = _b.sent();
          console.error(e_7);
          return [3
          /*break*/
          , 4];

        case 4:
          return [2
          /*return*/
          , {
            audit: false,
            guest: false
          }];
      }
    });
  });
} // 判断是否支持某个API

export function hasAppApi(api) {
  return __awaiter(this, void 0, void 0, function () {
    var _a, status, data;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          if (!(isJoJoApp && canUseBridge)) {
            return [2
            /*return*/
            , false];
          }

          return [4
          /*yield*/
          , bridge.call('hasApi', {
            methodName: api
          })];

        case 1:
          _a = _b.sent(), status = _a.status, data = _a.data;
          return [2
          /*return*/
          , status === 200 && (data === null || data === void 0 ? void 0 : data.hasApi)];
      }
    });
  });
} // 获取平台

export function getApplePlatform() {
  return __awaiter(this, void 0, void 0, function () {
    var packMap, _a, _b, bundleID, hasApi, app;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          if (!isJoJoApp) {
            return [2
            /*return*/
            , {}];
          }

          packMap = {
            // 叫叫学院
            'dev.shusheng.jojoread': '1',
            'com.shusheng.jojoread': '1',
            // 全球化包名
            'com.jojoreading.international': '1',
            // 叫叫识字
            'com.tinmanarts.jojosherlock': '6',
            'com.jojoread.jojosherlock': '4',
            // 叫叫绘本
            'com.jojoread.huiben': '2',
            'com.jojoread.jojocalculate': '5',
            'com.mohezi.fairyland': '7',
            'com.tinman.app.play': '1',
            // 绿豆
            'cn.mohezi.beans': '11',
            'dev.mohezi.beans': '11',
            // jojoup重置版
            'com.f2so.echo': '12',
            // jojoup重置版-测试版
            'dev.f2so.echo': '12',
            // 豆豆
            'dev.tinkzo.pico': '14',
            'com.tinkzo.pico': '14' // 叫叫绘画
            // 'com.tinmanarts.painter': '',
            // 'com.jojoread.readcamp': '',
            // 'com.jojoread.jojosherlock': '4'

          };
          return [4
          /*yield*/
          , Promise.all([getAppInfo(), hasAppApi('openAppleIAPPay')])];

        case 1:
          _a = _c.sent(), _b = _a[0].bundleID, bundleID = _b === void 0 ? '' : _b, hasApi = _a[1];
          app = packMap[bundleID.toLowerCase()];

          if (!app || isApple() && !hasApi) {
            return [2
            /*return*/
            , {}];
          }

          return [2
          /*return*/
          , {
            platform: isApple() ? 1 : 2,
            app: app
          }];
      }
    });
  });
}
/**
 * 是否安装微信
 * @returns 安装情况
 */

export function isWechatInstalled() {
  return __awaiter(this, void 0, void 0, function () {
    var isJJWeChatInstalled, res, e_8;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          isJJWeChatInstalled = true;
          _a.label = 1;

        case 1:
          _a.trys.push([1, 4,, 5]);

          if (!(isJoJoApp && canUseBridge)) return [3
          /*break*/
          , 3];
          return [4
          /*yield*/
          , bridge.isWechatInstalled()];

        case 2:
          res = _a.sent();

          if (res.data) {
            isJJWeChatInstalled = Boolean(res.data.isInstalled);
          }

          _a.label = 3;

        case 3:
          return [3
          /*break*/
          , 5];

        case 4:
          e_8 = _a.sent();
          console.error(e_8);
          return [3
          /*break*/
          , 5];

        case 5:
          return [2
          /*return*/
          , isJJWeChatInstalled];
      }
    });
  });
}
/**
 * 判断是否为纯血鸿蒙
 * @returns {boolean}
 */

export var isHarmonyOsNextCompatible = function isHarmonyOsNextCompatible() {
  return __awaiter(void 0, void 0, void 0, function () {
    var canUse, _a, status_7, error_1;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          _b.trys.push([0, 5,, 6]);

          return [4
          /*yield*/
          , hasAppApi('isHarmonyOsNextCompatible')];

        case 1:
          canUse = _b.sent();
          if (!canUse) return [3
          /*break*/
          , 3];
          return [4
          /*yield*/
          , bridge.call('isHarmonyOsNextCompatible')];

        case 2:
          _a = _b.sent().status, status_7 = _a === void 0 ? 0 : _a;
          return [2
          /*return*/
          , status_7 === 200];

        case 3:
          return [2
          /*return*/
          , false];

        case 4:
          return [3
          /*break*/
          , 6];

        case 5:
          error_1 = _b.sent();
          return [2
          /*return*/
          , false];

        case 6:
          return [2
          /*return*/
          ];
      }
    });
  });
}; // 是否安装支付宝和微信

export var getWxAndAliExist = function getWxAndAliExist(payWay) {
  return __awaiter(void 0, void 0, void 0, function () {
    var wechatExist, alipayExist, isHarmony, res, _a, status_8, data, error_2, res, _b, status_9, data, error_3, error_4;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          wechatExist = true;
          alipayExist = true;
          if (!(isJoJoBrowser() && canUseBridge)) return [3
          /*break*/
          , 13];
          if (!isJoJoUpBrowser()) return [3
          /*break*/
          , 2];
          return [4
          /*yield*/
          , isHarmonyOsNextCompatible()];

        case 1:
          isHarmony = _c.sent();

          if (isHarmony) {
            return [2
            /*return*/
            , {
              wechatExist: wechatExist,
              alipayExist: alipayExist
            }];
          }

          _c.label = 2;

        case 2:
          _c.trys.push([2, 12,, 13]);

          if (!(payWay === 100)) return [3
          /*break*/
          , 7];
          _c.label = 3;

        case 3:
          _c.trys.push([3, 5,, 6]);

          return [4
          /*yield*/
          , bridge.isWechatInstalled()];

        case 4:
          res = _c.sent();
          console.log('wxRes', res);
          _a = res || {}, status_8 = _a.status, data = _a.data;

          if (!(status_8 === 200 && data && data.isInstalled)) {
            wechatExist = false;
          }

          return [3
          /*break*/
          , 6];

        case 5:
          error_2 = _c.sent();
          wechatExist = false;
          console.log('wxError', error_2);
          return [3
          /*break*/
          , 6];

        case 6:
          return [3
          /*break*/
          , 11];

        case 7:
          if (!(payWay !== 111)) return [3
          /*break*/
          , 11];
          _c.label = 8;

        case 8:
          _c.trys.push([8, 10,, 11]);

          return [4
          /*yield*/
          , bridge.isAppInstalled({
            packageName: 'com.eg.android.AlipayGphone',
            urlScheme: 'alipays://'
          })];

        case 9:
          res = _c.sent();
          console.log('aliRes', res);
          _b = res || {}, status_9 = _b.status, data = _b.data;

          if (!(status_9 === 200 && data && data.isInstalled)) {
            alipayExist = false;
          }

          return [3
          /*break*/
          , 11];

        case 10:
          error_3 = _c.sent();
          alipayExist = false;
          console.log('aliError', error_3);
          return [3
          /*break*/
          , 11];

        case 11:
          return [3
          /*break*/
          , 13];

        case 12:
          error_4 = _c.sent();
          console.log(error_4);
          return [3
          /*break*/
          , 13];

        case 13:
          return [2
          /*return*/
          , {
            wechatExist: wechatExist,
            alipayExist: alipayExist
          }];
      }
    });
  });
}; // 延时调用

export function sleep(time) {
  if (time === void 0) {
    time = 1000;
  }

  return __awaiter(this, void 0, void 0, function () {
    var timer;
    return __generator(this, function (_a) {
      timer = null;
      return [2
      /*return*/
      , new Promise(function (resolve) {
        if (!timer) {
          timer = setTimeout(function () {
            resolve(true);
            timer = null;
          }, time);
        }
      })];
    });
  });
} // 刷新广场

export var refreshAppSquare = function refreshAppSquare(time) {
  if (time === void 0) {
    time = 1000;
  }

  return __awaiter(void 0, void 0, void 0, function () {
    function refreshInit() {
      return __awaiter(this, void 0, void 0, function () {
        var canIUse, canIUseCoursePlan, error_5;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              _a.trys.push([0, 6,, 7]); // 仅在jojoApp内实现


              if (!isJoJoReadBrowser()) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , sleep(time)];

            case 1:
              _a.sent();

              return [4
              /*yield*/
              , hasAppApi('refreshSquare')];

            case 2:
              canIUse = _a.sent();
              if (!canIUse) return [3
              /*break*/
              , 4]; // 当前桥 只调用 APP端没有返回状态处理

              return [4
              /*yield*/
              , bridge.call('refreshSquare')];

            case 3:
              // 当前桥 只调用 APP端没有返回状态处理
              _a.sent();

              _a.label = 4;

            case 4:
              return [4
              /*yield*/
              , hasAppApi('refreshCoursePlan')];

            case 5:
              canIUseCoursePlan = _a.sent();

              if (canIUseCoursePlan) {
                bridge.call('refreshCoursePlan');
              }

              return [3
              /*break*/
              , 7];

            case 6:
              error_5 = _a.sent();
              customError({
                name: '调用APP刷新广场/学习失败',
                message: error_5 === null || error_5 === void 0 ? void 0 : error_5.message,
                stack: error_5 === null || error_5 === void 0 ? void 0 : error_5.stack
              });
              return [3
              /*break*/
              , 7];

            case 7:
              return [2
              /*return*/
              ];
          }
        });
      });
    }

    return __generator(this, function (_a) {
      return [2
      /*return*/
      , new Promise(function (res) {
        var timer = setTimeout(function () {
          res(undefined);

          if (timer) {
            clearTimeout(timer);
            timer = null;
          }
        }, 1500);
        refreshInit().then(function () {
          res(undefined);
        }).catch(function () {
          res(undefined);
        });
      })];
    });
  });
};

function appTrigger(triggerName) {
  if (window.jsToApp[triggerName] && typeof window.jsToApp[triggerName] === 'function') {
    return window.jsToApp[triggerName]();
  } else {
    console.log("there isn't a function".concat(triggerName));
    return false;
  }
}

var AppShare = function AppShare(eventName, data, cb) {
  if (!canUseBridge) {
    var alt = window.alert;
    alt('出错了，请重试');
    return;
  }

  if (eventName === 'shareImageToWXCircle') {
    var bridgeData = {
      platformType: 0,
      title: data === null || data === void 0 ? void 0 : data.title,
      desc: data === null || data === void 0 ? void 0 : data.desc,
      url: data === null || data === void 0 ? void 0 : data.url,
      scene: data === null || data === void 0 ? void 0 : data.scene,
      shareType: 0,
      image: data === null || data === void 0 ? void 0 : data.image
    };
    bridge.call('shareToPlatform', bridgeData, function (res) {
      if (res === void 0) {
        res = {};
      }

      if (typeof cb === 'function') {
        cb(res);
      }
    });
  } else {
    bridge.call('shareMiniProgram', __assign({
      appId: envName === 'pro' ? 'gh_4766cc74fd5d' : 'gh_87f2400c676b',
      path: "/pages/transform_space/main?type=webview&needLogin=1&linkUrl=".concat(encodeURIComponent(data.url)),
      type: 0
    }, data), function (res) {
      if (res === void 0) {
        res = {};
      }

      if (typeof cb === 'function') {
        cb(res);
      }
    });
  }
};

var appShareH5Config = function appShareH5Config(_a) {
  var data = _a.data,
      menuShareClick = _a.menuShareClick,
      onShare = _a.onShare,
      sharePageToWXCircle = _a.sharePageToWXCircle,
      sharePageToWX = _a.sharePageToWX,
      notShowShare = _a.notShowShare;
  var appShareData = {
    title: (data === null || data === void 0 ? void 0 : data.title) || document.title,
    desc: (data === null || data === void 0 ? void 0 : data.desc) || '',
    // imgUrl:
    //   data?.imgUrl ||
    //   'https://jojopublic.oss-cn-hangzhou.aliyuncs.com/jojoread/wxapp/course/default-avatar-share.png',
    image: (data === null || data === void 0 ? void 0 : data.imgUrl) || 'https://jojopublic.oss-cn-hangzhou.aliyuncs.com/jojoread/wxapp/course/default-avatar-share.png',
    // link: data?.link || window.location.href,
    url: (data === null || data === void 0 ? void 0 : data.link) || window.location.href
  };
  var query = qsParse();
  var noShare = notShowShare || (query === null || query === void 0 ? void 0 : query.ns) === '1';

  if (isJoJoBrowser()) {
    var params = {
      showShare: !noShare
    };
    bridge.call('menuShare', params);
    if (noShare) return;

    if (!window.jsToApp) {
      window.jsToApp = {};
    }

    window.appTrigger = appTrigger; // 右上角分享按钮点击

    window.jsToApp.menuShareClick = function () {
      if (menuShareClick) menuShareClick();
      if (onShare) onShare();
    }; // 分享到朋友圈点击


    window.jsToApp.sharePageToWXCircle = function () {
      if (sharePageToWXCircle) sharePageToWXCircle();
      AppShare('shareImageToWXCircle', __assign(__assign({}, appShareData), {
        scene: 1
      }), function (res) {
        console.log(res);
      });
    }; // 分享到好友点击


    window.jsToApp.sharePageToWX = function () {
      if (sharePageToWX) sharePageToWX();
      AppShare('shareImageToWXCircle', __assign(__assign({}, appShareData), {
        scene: 0
      }), function (res) {
        console.log(res);
      });
    };
  }
};
/**
 * 拦截或取消拦截APP的自动返回操作
 * @param intercepted - 一个字符串枚举值，'true' 表示拦截，'false' 表示取消拦截
 * @param callBack - 可选的回调函数，在拦截或取消拦截操作完成后执行
 */


function doIntercept(intercepted, callBack) {
  return __awaiter(this, void 0, void 0, function () {
    var hasInterceptGoBackAction, error_6;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);

          return [4
          /*yield*/
          , hasAppApi('interceptAutoGoBackAction')];

        case 1:
          hasInterceptGoBackAction = _a.sent(); // 如果APP支持该API，则调用它进行拦截或取消拦截操作

          if (hasInterceptGoBackAction) {
            // 调用桥接方法拦截或取消拦截APP的自动返回操作
            bridge.call('interceptAutoGoBackAction', {
              intercepted: intercepted
            }, function (res) {
              // 打印拦截或取消拦截操作的结果
              console.log("intercept".concat(intercepted, "===="), res); // 如果提供了回调函数，则执行该回调函数

              if (typeof callBack === 'function') {
                callBack();
              }
            });
          }

          return [3
          /*break*/
          , 3];

        case 2:
          error_6 = _a.sent(); // 捕获并打印错误信息

          console.log(error_6);
          return [3
          /*break*/
          , 3];

        case 3:
          return [2
          /*return*/
          ];
      }
    });
  });
}
/**
 * 拦截APP的返回操作，并在用户触发返回或关闭事件时，调用回调函数
 */


export function interceptReadAppEvaluationBack(_a) {
  var onClose = _a.onClose,
      onBack = _a.onBack;

  try {
    if (isJoJoReadBrowser() && canUseBridge) {
      // 调用拦截函数，拦截APP的自动返回操作
      doIntercept('true'); // 监听app返回｜关闭事件

      bridge.on('appCalljs_autoGoBackFn', function (res) {
        // 点击左上角关闭时 直接退出页面
        if ((res === null || res === void 0 ? void 0 : res.type) === 'close') {
          onClose === null || onClose === void 0 ? void 0 : onClose(); // 阻止APP执行默认的返回操作

          return {
            goBack: false
          };
        } // 当用户点击返回按钮时


        if ((res === null || res === void 0 ? void 0 : res.type) === 'back') {
          onBack === null || onBack === void 0 ? void 0 : onBack(); // 阻止APP执行默认的返回操作

          return {
            goBack: false
          };
        } // 其他情况也阻止APP执行默认的返回操作


        return {
          goBack: false
        };
      });
    }
  } catch (error) {
    // 打印错误信息
    console.log(error); // 上报自定义错误信息到监控系统

    customError({
      name: '拦截返回事件错误',
      message: error === null || error === void 0 ? void 0 : error.message,
      stack: error === null || error === void 0 ? void 0 : error.stack
    });
  }
}
/**
 * 跳转到APP指定路由
 * @param appUrl - 要跳转的APP路由地址
 */

export function jumpAppRoute(appUrl) {
  return __awaiter(this, void 0, void 0, function () {
    var isMiniWindow, hasApi;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          isMiniWindow = getIsWindowModel();
          if (!isMiniWindow) return [3
          /*break*/
          , 4];
          return [4
          /*yield*/
          , hasAppApi('closeMiniWindow')];

        case 1:
          hasApi = _a.sent();
          if (!hasApi) return [3
          /*break*/
          , 3]; // 调用 closeMiniWindow API 关闭小程序窗口并跳转到指定的APP路由

          return [4
          /*yield*/
          , bridge.call('closeMiniWindow', {
            jumpUrl: appUrl
          })];

        case 2:
          // 调用 closeMiniWindow API 关闭小程序窗口并跳转到指定的APP路由
          _a.sent();

          _a.label = 3;

        case 3:
          return [3
          /*break*/
          , 5];

        case 4:
          // 豆豆app内不支持deepLink
          if (isDouDouBrowser()) {
            bridge.call('closeH5AndJump', {
              url: appUrl
            });
          } else {
            // 若不处于小程序窗口模式，直接使用 window.location.replace 替换当前页面为指定的APP路由
            window.location.replace(appUrl);
          }

          _a.label = 5;

        case 5:
          return [2
          /*return*/
          ];
      }
    });
  });
}
export { appShareH5Config, canUseBridge, jojoAppDirectLogin, jojoAppLogin, jojoAppOnlyDirectLogin, jojoWeChatInstalled, tinmanWxtrigger };
export default bridge;